export default __webpack_public_path__ + "_/images/stories/pig-eb1c632ba7707b2a8e15f9dba17bc9a73067fe4ea6ff60f83d58f267b08b52fe.png";